export const CarrierLaneSearchRoute = {
  path: '/carrier/lanesearch',
  load: () => import('./LaneSearch'),
  protected: true,
};
